import * as SmartyStreetsSDK from 'smartystreets-javascript-sdk'

/**
 * @classdesc Address Qualification
 * method that returns a promise that resolves with address options based on the given input
 */
class AddressQualification {
  /**
   * @param {string} smartyStreetsWebsiteKey - string of numbers that represents the key Smarty Streets SDK needs
   */
  constructor({ smartyStreetsWebsiteKey }) {
    this.SmartyStreetsCore = SmartyStreetsSDK.core
    this.SmartyStreetsAutoLookup = SmartyStreetsSDK.usAutocomplete.Lookup
    this.SmartyStreetsStreetLookup = SmartyStreetsSDK.usStreet.Lookup
    this.WebsiteKey = smartyStreetsWebsiteKey
    this.credentials = new this.SmartyStreetsCore.SharedCredentials(
      this.WebsiteKey
    )
    this.AutoClient = this.SmartyStreetsCore.buildClient.usAutocomplete(
      this.credentials
    )
    this.AddressClient = this.SmartyStreetsCore.buildClient.usStreet(
      this.credentials
    )
  }

  /**
   * Hits the Smart Streets endpoint using the SDK and returns the results for a Select Dropdown
   * @param {string} query - string representing the text the user is inputting for their address
   * @return {array} - returns an array of objects containing the closest address matches to the give query
   */
  autofillSuggestions(query) {
    return new Promise((resolve, reject) => {
      if (!this.WebsiteKey) {
        reject(
          new Error(
            'Leshen:UI:AddressQualification - no smartyStreetsWebsiteKey used in intialization'
          )
        )
      }

      const lookup = new this.SmartyStreetsAutoLookup(query)

      this.AutoClient.send(lookup)
        .then((data) => {
          resolve(
            data.result.map((s) => ({
              label: s.text,
              value: s.text,
            }))
          )
        })
        .catch((err) =>
          reject(
            new Error(
              `Leshen:UI:AddressQualification - error pulling street suggestions from Smarty Streets: ${err}`
            )
          )
        )
    })
  }
}

export default AddressQualification
